import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=08751456&"
import script from "./PersonalDetails.vue?vue&type=script&lang=js&"
export * from "./PersonalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports